import { merge } from "lodash";
import {
  FETCH_FACTORINGATTACHMENTS_REQUEST,
  FETCH_FACTORINGATTACHMENTS_SUCCESS,
  FETCH_FACTORINGATTACHMENTS_FAILURE
} from "../types";

const fetchAttachments = (state, { type, payload }) => {
  switch (type) {
    case FETCH_FACTORINGATTACHMENTS_REQUEST:
      return {
        ...state,
        loadingAttachments: true
      };
    case FETCH_FACTORINGATTACHMENTS_SUCCESS:
      return {
        ...state,
        attachments: merge({}, state.attachments, payload),
        loadingAttachments: false
      };
    case FETCH_FACTORINGATTACHMENTS_FAILURE:
      return {
        ...state,
        loadingAttachments: false
      };
    default:
      return {
        ...state
      };
  }
};

export default fetchAttachments;
